import { Avatar } from 'shared/mui/Avatars';
import { Box } from 'shared/mui/Box';
import { Tooltip } from 'shared/mui/Tooltip';
import { WorkTeamMember } from 'types/embedded/workTeam';

import { StyledAvatarGroup, StyledBox } from './ProviderAccountsMembers.styled';

type Props = {
  addSlot?: React.ReactNode;
  members?: WorkTeamMember[];
};

export const ProviderAccountsMembers: React.FC<Props> = ({ addSlot, members }) => {
  return (
    <Box display="flex">
      <Tooltip arrow placement="bottom" title="Добавить ответственных">
        <StyledAvatarGroup sx={{ zIndex: 1 }}>{addSlot}</StyledAvatarGroup>
      </Tooltip>
      <Tooltip
        arrow
        placement="right"
        title={
          <Box flexDirection="column">
            {members?.map(({ firstName, lastName, id }) => (
              <StyledBox key={id}>{`${firstName} ${lastName}`}</StyledBox>
            ))}
          </Box>
        }
      >
        <StyledAvatarGroup max={4} sx={{ marginLeft: '-8px' }}>
          {members?.map((member) => (
            <Avatar
              key={member.id}
              sx={{ width: 24, height: 24, fontSize: '8px' }}
              title={`${member.firstName} ${member.lastName}`}
            >
              {`${member.firstName[0]}${member.lastName[0]}`.toUpperCase()}
            </Avatar>
          ))}
        </StyledAvatarGroup>
      </Tooltip>
    </Box>
  );
};
